<div class="routine-selector-modal">
    <!-- Header fijo -->
    <div class="modal-header">
        <h2 mat-dialog-title class="text-lg font-semibold text-gray-900 dark:text-gray-100 max-h-fit">
            Seleccionar rutina
        </h2>
        <button mat-icon-button (click)="closeModal()" class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Buscador -->
    <div class="search-section">
        <mat-form-field appearance="outline" class="w-full">
            <mat-label>Buscar rutina...</mat-label>
            <input matInput
                   [(ngModel)]="searchTerm"
                   (input)="onSearchChange()"
                   placeholder="Nombre, cluster, tipo o división">
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
    </div>

    <!-- Lista de rutinas con overflow -->
    <div class="routines-list">
        <div class="grid grid-cols-1 gap-4">
            @for (routine of filteredRoutines; track routine.id) {
                <div class="routine-card"
                     (click)="selectRoutine(routine)">

                    <!-- Cabecera de la rutina -->
                    <div class="flex items-start justify-between mb-3">
                        <h5 class="text-lg font-bold dark:text-gray-100 leading-tight">{{ routine.name }}</h5>
                        <mat-chip [color]="routine.routine_type_id === 1 ? 'accent' : 'primary'"
                                  class="text-xs font-medium ml-2 flex-shrink-0">
                            {{ routine.routine_type_id === 1 ? 'Semáforo' : 'Color Objetivo' }}
                        </mat-chip>
                    </div>

                    <!-- Descripción del tipo -->
                    <p class="text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-2 leading-relaxed">
                        {{ routine.routine_type?.description }}
                    </p>

                    <!-- Información de configuración -->
                    <div class="space-y-2 mb-3">
                        <div class="flex items-center justify-between text-sm">
                            <div class="flex items-center space-x-2">
                                <mat-icon class="text-base text-gray-500">shuffle</mat-icon>
                                <span class="dark:text-gray-300">
                                    {{ routine.random ? 'Aleatorio' : 'Secuencial' }}
                                </span>
                            </div>
                            <div class="flex items-center space-x-2" *ngIf="routine.steps">
                                <mat-icon class="text-base text-gray-500">format_list_numbered</mat-icon>
                                <span class="dark:text-gray-300">{{ routine.steps }} pasos</span>
                            </div>
                        </div>

                        <div class="flex items-center justify-between text-sm">
                            <div class="flex items-center space-x-2">
                                <mat-icon class="text-base text-gray-500">view_module</mat-icon>
                                <span class="dark:text-gray-300">{{ routine.cluster?.name }}</span>
                            </div>
                            <div class="flex items-center space-x-2">
                                <mat-icon class="text-base text-gray-500">devices</mat-icon>
                                <span class="dark:text-gray-300">
                                    {{ getDeviceCount(routine.table_data) }} dispositivos
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Divisiones -->
                    <div class="pt-3 border-t border-gray-200 dark:border-gray-600"
                         *ngIf="routine.divisions?.length">
                        <div class="text-xs text-gray-600 dark:text-gray-400 mb-2 font-medium">Divisiones:</div>
                        <div class="flex flex-wrap gap-1">
                            <mat-chip *ngFor="let division of routine.divisions" class="text-xs" color="warn">
                                {{ division.name }}
                            </mat-chip>
                        </div>
                    </div>
                </div>
            }
            @empty {
                <div class="text-center py-8 text-gray-500 dark:text-gray-400">
                    <mat-icon class="text-4xl mb-2">search_off</mat-icon>
                    <p>No se encontraron rutinas</p>
                </div>
            }
        </div>
    </div>

    <!-- Footer fijo -->
    <div class="modal-footer">
        <span class="routines-count">
            {{ filteredRoutines.length }} rutina{{ filteredRoutines.length !== 1 ? 's' : '' }} encontrada{{ filteredRoutines.length !== 1 ? 's' : '' }}
        </span>
        <button mat-raised-button color="warn" (click)="closeModal()">
            Cancelar
        </button>
    </div>
</div>
